import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`新加坡商鈦坦科技 ScrumMaster, 喜歡促進人與人之間的對話，協助團隊探索並轉換更有效能的協作方式。 2014 年開始體驗敏捷, 目前協助單一團隊運用 Scrum 實踐敏捷，也協助多團隊共同協作的改善。認為敏捷的工作方式除了能在不確定的環境中探索以外，也能藉由目標對齊下的自組織釋放團隊手、腦、心的潛能持續改善，持續交付產品價值，讓產品和團隊的透明、檢視和改善不斷的成長`}</p>
    <p>{`影片: `}<a parentName="p" {...{
        "href": "https://youtu.be/obCs-Odsd3s"
      }}>{`https://youtu.be/obCs-Odsd3s`}</a></p>
    <p>{`相關演講經歷:`}</p>
    <ol>
      <li parentName="ol">{`Regional Scrum Gathering Tokyo 2020`}</li>
      <li parentName="ol">{`Agile Tour Kaoshiung 2019`}</li>
      <li parentName="ol">{`Agile Summit 台北敏捷高峰會 2019`}</li>
      <li parentName="ol">{`AgileCommunity.tw`}</li>
      <li parentName="ol">{`Agile Community in 內湖`}</li>
      <li parentName="ol">{`C.C Agile`}</li>
      <li parentName="ol">{`東吳大學`}</li>
      <li parentName="ol">{`宜蘭大學`}</li>
      <li parentName="ol">{`精英電腦`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      